angular.module('impactx.favorites').controller('FavoriteOverviewCtrl', [
    '$scope',
    'dataGen',
    'ToolbarService',
    'SearchService',
    'SearchFilter',
    'sidebarShow',
    FavoriteController
]);

function FavoriteController($scope, dataGen, ToolbarService, SearchService, SearchFilter, sidebarShow) {

    var self = this;
    self.initialized = false;

    ToolbarService.showSearchFilterToggle();
    SearchFilter.setFilterIdentifier('favorite');

    self.searchAll = function () {
        return SearchService.searchAll(SearchFilter.getFilters(), '/favorite/list').then(function (searchResult) {
            ToolbarService.setButtons([]);
            $scope.data = searchResult
            $scope.trns = searchResult.trns;
            self.initialized = true;
        });
    };

    self.isSidebarOpen = function () {
        return sidebarShow.isOpen();
    };

    $scope.$on('$destroy', function () {
        SearchFilter.setFilterIdentifier();
    });

    self.searchAll();
}
